import React from "react";

import { MedicalHistoryCard } from "components/PatientDetailCardWithOverview/components/PatientOverviewModal/components/MedicalHistory/MedicalHistoryCard";
import { PatientDetailCard } from "features/patients/components/PatientDetailCard/index.js";

import { AlergiesIntolerance as AllergiesIntolerance } from "./components/AllergiesIntolerance/AllergiesIntolerance.jsx";
import { Appointments } from "./components/Appointments";
import { Consent } from "./components/Consent/Consent.jsx";
import { FamilyMedicalHistory } from "./components/FamilyMedicalHistory/FamilyMedicalHistory.jsx";
import { HealthIdentifiers } from "./components/HealthIdentifiers/HealthIdentifiers.jsx";
import { PaymentsSummary } from "./components/PaymentsSummary/PaymentsSummary.jsx";
import { Preferences } from "./components/Preferences/Preferences.jsx";
import { Social } from "./components/Social/Social.jsx";
import { TasksSummary } from "./components/TasksSummary/TasksSummary.jsx";
import s from "./PatientDetailsPage.module.css";

export const PatientDetailsPage = () => {
  return (
    <div style={{ margin: "0 auto" }}>
      <div className={s.wrapper}>
        <div className={s.firstColumnWrapper}>
          <PatientDetailCard />
          <PaymentsSummary />
          <TasksSummary />
          <AllergiesIntolerance />
          <FamilyMedicalHistory />
        </div>
        <div className={s.secondColumnWrapper}>
          <MedicalHistoryCard />
          <Appointments />
          <div className={s.secondColumnSubWrapper}>
            <Social />
            <Preferences />
          </div>
          <div className={s.thirdColumnWrapper}>
            <HealthIdentifiers />
            <Consent />
          </div>
        </div>
      </div>
    </div>
  );
};
